const Info = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4_14725)">
                <path d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" style={{stroke: 'var(--secondary-color)'}} stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99957 7.98035C9.41408 7.98035 9.75011 8.31638 9.75011 8.73089L9.75011 12.0666C9.75011 12.4812 9.41408 12.8172 8.99957 12.8172C8.58505 12.8172 8.24902 12.4812 8.24902 12.0666L8.24902 8.73089C8.24902 8.31638 8.58505 7.98035 8.99957 7.98035Z" style={{fill: 'var(--secondary-color)'}} />
                <circle cx="8.99957" cy="5.9334" r="0.750543" style={{fill: 'var(--secondary-color)'}} />
            </g>
            <defs>
                <clipPath id="clip0_4_14725">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default Info;
